const LOGO = "/images/logo.png";
const STRATAGILE_LOGO = "/images/STRATAGILE_LOGO.png";
const SYNERGETICS_LOGO = "/images/SYNERGETICS_LOGO.png";
const COVER_IMAGE = "/png/LoginLogo.png";
const RIGHT_ARROW = "/images/arrow-sm-right.png";
const BACK_BTN = "/svg/backBtn.svg";
const HOME_BTN = "/svg/homeBtnGray.svg";
const QR_BTN = "/svg/qrBtnGray.svg";
const PROFILE_BTN = "/svg/profileBtnGray.svg";
const EMPTY_BOOK = "/svg/emptyBooks.svg";
const COVER_VIDEO = "/svg/video-placeholder.png";
const LOGOUT = "/ButtonIcons/logout.svg";
const AVATAR = "/images/dp.jpeg";
const DUMMY_VIDEO_COVER = "/DummyImages/video_cover.svg";
const PDF = "/svg/pdf.svg";
const PDF2 = "svg/pdf.png";
const PPTX = "svg/icons8-pptx.svg";
const DOCX =
  "svg/icons8-docx-64.png                                                                                                                  ";
const RIGHT_TICK = "/svg/correctTick.svg";
const WRONG_TICK = "/svg/wrongTick.svg";
const LOADER_SVG = "/svg/loader.svg";
const DEFAULT_COVER = "/svg/defaultCover.svg";
const DEMO_COVER = "/images/demobanner.svg";
const UPLOAD_ICON = "/svg/new-upload-icon.svg";
const CHECK_ICON = "/svg/success-check-icon.svg";
const LOADER_MPLE = "/images/logo-spinner.gif";
const SHARE_BTN = "/svg/share1.svg";
const WEBSITE_BTN = "/svg/world1.svg";
const EXPERIENCE = "/svg/experience.svg";
const JOB_TYPE = "/svg/jobType1.svg";
const LOCATION_PIN = "/svg/location-pin1.svg";
const SALARY_BTN = "/svg/salary1.svg";
const ARROW_RIGHT = "/svg/arrowRight.svg";
const INVALID_RESUME = "/svg/images/invalid-resume.svg";
const DEMO_1 = "/svg/images/demo-1.svg";
const DEMO_2 = "/svg/images/demo-22.svg";
const DEMO_3 = "/svg/images/demo-3.svg";
const DEMO_4 = "/svg/images/demo-4.svg";
const DEMO_5 = "/svg/images/demo-51.svg";
const DEMO_1_MOB = "/svg/images/Demo_1_Mob.svg";
const DEMO_2_MOB = "/svg/images/Demo_2Mob.svg";
const DEMO_3_MOB = "/svg/images/Demo_3Mob.svg";
const DEMO_4_MOB = "/svg/images/Demo_4_Mob.svg";
const DEMO_5_MOB = "/svg/images/Demo_5_Mob.svg";
const YES_TICK = "/svg/yes-alt.svg";
const REMOVE = "/svg/remove.svg";
const WARN = "/svg/warn.svg";
const NO_QUESTION_ICON = "/svg/No-Ans.svg";
const RESULT_PROGRESS_ICON = "/svg/interview-progress.svg";
const ROLEPLAY_1 = "/svg/roleplay_1.svg";
const ROLEPLAY_2 = "/svg/roleplay_2.svg";
const RESUME_NOT_PROCESS = "/png/resume-coudnt-process.png";
const CODEB_LOGO = "/svg/codeb_logo.svg";
const SIGNATURE = "/svg/signature.svg";
const REWARD_INACTIVE = "/svg/reward1.svg";
const REWARD_ACTIVE = "/svg/reward2.svg";
const LEADER_ACTIVE = "/svg/leader1.svg";
const LEADER_INACTIVE = "/svg/leader2.svg";
const GOLD = "/svg/gold.svg";
const SILVER = "/svg/silver.svg";
const BRONZE = "/svg/bronze.svg";
const DownloadIcon = "/svg/download.svg";

const GOLD1 = "/svg/gold.png";
const SILVER1 = "/svg/silver.png";
const BRONZE1 = "/svg/bronze.png";
const AI_COACH_INFO = "/png/ai_coach_info.png";
const EVALUATION_INFO = "/png/evaluation_info.png";
const ROLEPLAY_INFO = "/png/roleplay_info.png";
const CORRECT_TICK = "/svg/activity-correct-icon.svg";
const CONNECTION_LOST = "/images/ConnectionLost.png";
const CONNECTION_LOST_SVG = "/svg/ConnectionLost.svg";
const COACH_HISTORY_SVG = "/svg/ppt-svgrepo-com 2.svg";

export {
  PDF2,
  PPTX,
  DOCX,
  LOGO,
  STRATAGILE_LOGO,
  SYNERGETICS_LOGO,
  COVER_IMAGE,
  BACK_BTN,
  HOME_BTN,
  QR_BTN,
  PROFILE_BTN,
  EMPTY_BOOK,
  DUMMY_VIDEO_COVER,
  PDF,
  COVER_VIDEO,
  LOGOUT,
  RIGHT_ARROW,
  AVATAR,
  RIGHT_TICK,
  WRONG_TICK,
  LOADER_SVG,
  DEFAULT_COVER,
  DEMO_COVER,
  UPLOAD_ICON,
  CHECK_ICON,
  LOADER_MPLE,
  SHARE_BTN,
  WEBSITE_BTN,
  EXPERIENCE,
  LOCATION_PIN,
  JOB_TYPE,
  SALARY_BTN,
  ARROW_RIGHT,
  INVALID_RESUME,
  DEMO_1,
  DEMO_2,
  DEMO_3,
  DEMO_4,
  DEMO_5,
  DEMO_1_MOB,
  DEMO_2_MOB,
  DEMO_3_MOB,
  DEMO_4_MOB,
  DEMO_5_MOB,
  YES_TICK,
  REMOVE,
  WARN,
  NO_QUESTION_ICON,
  RESULT_PROGRESS_ICON,
  ROLEPLAY_1,
  ROLEPLAY_2,
  RESUME_NOT_PROCESS,
  CODEB_LOGO,
  SIGNATURE,
  REWARD_ACTIVE,
  REWARD_INACTIVE,
  LEADER_ACTIVE,
  LEADER_INACTIVE,
  GOLD,
  SILVER,
  BRONZE,
  GOLD1,
  SILVER1,
  BRONZE1,
  AI_COACH_INFO,
  EVALUATION_INFO,
  ROLEPLAY_INFO,
  DownloadIcon,
  CORRECT_TICK,
  CONNECTION_LOST,
  CONNECTION_LOST_SVG,
  COACH_HISTORY_SVG,
};
